import { when } from 'mobx';
import { runtime } from '../../Runtime';
export class BrowserBoot {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get browserRuntime() {
        return this.parent;
    }
    async bootBrowserRuntime() {
        const user = when(() => this.browserRuntime.app.user.userQuery.triggeredIsAvailable);
        const topic = when(() => !!this.browserRuntime.app.topic);
        const requirements = [user, topic];
        if (runtime.runtimePermissions.hasEditFunctionality) {
            await when(() => !!runtime.streamedPackages.Edit);
        }
        if (window.firstQuestionId) {
            console.log('window.firstQuestionId', window.firstQuestionId);
            requirements.push(this.browserRuntime.app.directive.directivePoseQuestion.poseQuestionById(window.firstQuestionId));
        }
        await Promise.all(requirements);
        this.browserRuntime.browserRender.renderApp();
        this.browserRuntime.app.appBoot.isAppRendered = true;
    }
    async urlToPreloadPromise(cache, preloadUrl) {
        const response = await cache.match(preloadUrl);
        if (response) {
            try {
                const json = await response.json();
                return json;
            }
            catch (e) {
                console.warn(e);
                return undefined;
            }
            return undefined;
        }
    }
}
